
import { Messages } from '@tableau/catalog-messages';
import { LabelManagementLink } from '@tableau/catalog-ui-temp';
import { ListItem } from '@tableau/widgets';
import React from 'react';

export function listWithLabelLink(): ListItem[]{
  return [
    {separator: true},
    {value: Messages.labelManagementLink(),
    content: (<LabelManagementLink />) }
  ];
}
